import debounce from 'lodash.debounce';

const persianNumberRegexp = /[۰۱۲۳۴۵۶۷۸۹]/g;

/* eslint-disable */
export default function normalize(num) {
  if (typeof num === 'string') {
    return num.replace(
      persianNumberRegexp,
      ch => String.fromCharCode(ch.charCodeAt(0) - 1776 + 48),
    );
  }

  if (num && typeof num === 'object') {
    for (const key in num) {
      if (({}).hasOwnProperty.call(num, key)) {
        num[key] = normalize(num[key]);
      }
    }
  }

  return num;
}

export const debouncedNormalize = debounce(normalize, 500);
